var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter1042031Blue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "printer_1042036 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40.6696 2.1842H14.3299C13.9135 2.1842 13.5759 2.52184 13.5759 2.93821V17.5339C13.5759 17.9501 13.9135 18.2878 14.3299 18.2878C14.7464 18.2878 15.0839 17.9501 15.0839 17.5338V3.69221H39.9156V17.5338C39.9156 17.9501 40.2532 18.2878 40.6696 18.2878C41.0861 18.2878 41.4236 17.9501 41.4236 17.5338V2.93821C41.4236 2.52184 41.0861 2.1842 40.6696 2.1842Z",
    fill: "#3C7AF5",
    stroke: "#3C7AF5",
    strokeWidth: 0.423077
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40.5958 35.8623H41.6208C42.0373 35.8623 42.3748 35.5246 42.3748 35.1082C42.3748 34.6919 42.0373 34.3542 41.6208 34.3542H13.3788C12.9623 34.3542 12.6248 34.6919 12.6248 35.1082C12.6248 35.5246 12.9623 35.8623 13.3788 35.8623H14.4038L13.137 47.6754C13.0927 48.0895 13.3922 48.4611 13.8062 48.5055C14.2226 48.5503 14.5919 48.2501 14.6363 47.8363L15.9203 35.8624H39.0791L40.7354 51.3078H14.264L14.3665 50.3531C14.4109 49.9391 14.1113 49.5675 13.6973 49.523C13.2844 49.4788 12.9116 49.7783 12.8672 50.1923L12.6753 51.9814C12.6524 52.1941 12.7211 52.4066 12.8641 52.5658C13.0072 52.725 13.2111 52.8158 13.425 52.8158H41.5748C41.7887 52.8158 41.9927 52.7249 42.1357 52.5658C42.2786 52.4067 42.3473 52.1943 42.3245 51.9814L40.5958 35.8623Z",
    fill: "#3C7AF5",
    stroke: "#3C7AF5",
    strokeWidth: 0.423077
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M43.887 19.1371H7.0274C4.31898 19.1371 2.11548 21.3407 2.11548 24.0491V40.8562C2.11548 43.5646 4.31898 45.7682 7.0274 45.7682H11.6668C12.0833 45.7682 12.4208 45.4306 12.4208 45.0142C12.4208 44.5979 12.0833 44.2602 11.6669 44.2602H7.0274C5.15043 44.2602 3.62348 42.7332 3.62348 40.8562V24.0491C3.62348 22.1721 5.15053 20.6451 7.0274 20.6451H43.887C44.3034 20.6451 44.641 20.3075 44.641 19.8911C44.641 19.4747 44.3035 19.1371 43.887 19.1371Z",
    fill: "#3C7AF5",
    stroke: "#3C7AF5",
    strokeWidth: 0.423077
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M47.9716 19.1371H46.4003C45.9838 19.1371 45.6463 19.4747 45.6463 19.8911C45.6463 20.3075 45.9838 20.6451 46.4003 20.6451H47.9716C49.8491 20.6451 51.3766 22.1721 51.3766 24.0491V40.8562C51.3766 42.7332 49.849 44.2602 47.9716 44.2602H43.3321C42.9157 44.2602 42.5781 44.5979 42.5781 45.0142C42.5781 45.4306 42.9157 45.7682 43.3321 45.7682H47.9716C50.6806 45.7682 52.8846 43.5647 52.8846 40.8562V24.0491C52.8846 21.3407 50.6806 19.1371 47.9716 19.1371Z",
    fill: "#3C7AF5",
    stroke: "#3C7AF5",
    strokeWidth: 0.423077
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M43.9874 30.7992H11.0125C10.5961 30.7992 10.2585 31.1368 10.2585 31.5532V39.5959C10.2585 40.0122 10.5961 40.3499 11.0125 40.3499H12.2479C12.6643 40.3499 13.0019 40.0122 13.0019 39.5959C13.0019 39.1795 12.6643 38.8419 12.2479 38.8419H11.7665V32.3072H43.2335V38.8419H42.7521C42.3357 38.8419 41.9981 39.1795 41.9981 39.5959C41.9981 40.0122 42.3357 40.3499 42.7521 40.3499H43.9875C44.4039 40.3499 44.7415 40.0122 44.7415 39.5959V31.5532C44.7414 31.1367 44.4039 30.7992 43.9874 30.7992Z",
    fill: "#3C7AF5",
    stroke: "#3C7AF5",
    strokeWidth: 0.423077
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.59976 22.2538C6.74271 22.2538 5.23193 23.7646 5.23193 25.6216C5.23193 27.4787 6.74271 28.9894 8.59976 28.9894C10.4568 28.9894 11.9676 27.4787 11.9676 25.6216C11.9676 23.7646 10.4568 22.2538 8.59976 22.2538ZM8.59976 27.4814C7.57426 27.4814 6.73994 26.6471 6.73994 25.6216C6.73994 24.5961 7.57426 23.7618 8.59976 23.7618C9.62526 23.7618 10.4596 24.5961 10.4596 25.6216C10.4596 26.6471 9.62526 27.4814 8.59976 27.4814Z",
    fill: "#3C7AF5",
    stroke: "#3C7AF5",
    strokeWidth: 0.423077
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M16.4413 22.2538C14.5843 22.2538 13.0735 23.7646 13.0735 25.6216C13.0735 27.4787 14.5843 28.9894 16.4413 28.9894C18.2984 28.9894 19.8091 27.4787 19.8091 25.6216C19.8092 23.7646 18.2984 22.2538 16.4413 22.2538ZM16.4413 27.4814C15.4158 27.4814 14.5815 26.6471 14.5815 25.6216C14.5815 24.5961 15.4158 23.7618 16.4413 23.7618C17.4668 23.7618 18.3011 24.5961 18.3011 25.6216C18.3011 26.6471 17.4669 27.4814 16.4413 27.4814Z",
    fill: "#3C7AF5",
    stroke: "#3C7AF5",
    strokeWidth: 0.423077
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M37.3015 46.8845H17.6976C17.2811 46.8845 16.9436 47.2222 16.9436 47.6385C16.9436 48.0549 17.2811 48.3925 17.6976 48.3925H37.3016C37.718 48.3925 38.0556 48.0549 38.0556 47.6385C38.0556 47.2222 37.718 46.8845 37.3015 46.8845Z",
    fill: "#3C7AF5",
    stroke: "#3C7AF5",
    strokeWidth: 0.423077
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M36.8244 43.4661H18.1751C17.7588 43.4661 17.4211 43.8037 17.4211 44.2201C17.4211 44.6364 17.7587 44.9741 18.1751 44.9741H36.8243C37.2408 44.9741 37.5783 44.6364 37.5783 44.2201C37.5783 43.8037 37.2409 43.4661 36.8244 43.4661Z",
    fill: "#3C7AF5",
    stroke: "#3C7AF5",
    strokeWidth: 0.423077
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M36.4221 40.0481H18.5772C18.1608 40.0481 17.8232 40.3857 17.8232 40.8021C17.8232 41.2185 18.1608 41.5561 18.5772 41.5561H36.4221C36.8386 41.5561 37.1761 41.2185 37.1761 40.8021C37.1761 40.3857 36.8387 40.0481 36.4221 40.0481Z",
    fill: "#3C7AF5",
    stroke: "#3C7AF5",
    strokeWidth: 0.423077
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter1042031Blue);
export default __webpack_public_path__ + "static/media/printer_104203_1_blue.c77fe8e424511ec9eef0cd5caac6963f.svg";
export { ForwardRef as ReactComponent };